import { loadSharesForPartnership } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-shared-resources';
import type { SharedResourceItem } from '@efdigital/ll-xceed-v2/data/types/coaching-shared-resource';
import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoacheeCohortResourcesModel = CoachingCoacheeCohortModel & {
  items: SharedResourceItem[];
};

export default class CoachingCoacheeCohortResourcesRoute extends Route<CoachingCoacheeCohortResourcesModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortResourcesModel> {
    const parent = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const pages = await Promise.all(
      parent.planner.chemistryAndChosenPartnerships.map((partnership) =>
        loadSharesForPartnership(this.store, partnership.id!)
      )
    );

    return {
      ...parent,
      items: pages.flat(),
    };
  }
}
